const middleware = {}

middleware['auth'] = require('../middleware/auth.ts')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['unsavedChangesHelper'] = require('../middleware/unsavedChangesHelper.ts')
middleware['unsavedChangesHelper'] = middleware['unsavedChangesHelper'].default || middleware['unsavedChangesHelper']

export default middleware
